<template>

    <div>
        <Loading/>
        <MenuInternoCadastros/>
        <span><strong>- EXECUÇÕES <i class="fas fa-chevron-right"></i> LISTAGEM
      <span v-if="paginaTop != ''"><i class="fas fa-chevron-right"></i> {{paginaTop}}</span></strong></span>

        <div v-if="listagem == 'listagem'">
            <div class="text-right mb-2">
                <button class="btn btn-sm btn-success" @click="viewAdicionar">Adicionar Tipo de Execução</button>
            </div>
            <table id="tabela" class="table table-striped table-responsive-sm">
                <thead>
                <tr>
                    <th>Id</th>
                    <th class="text-center">Descrição</th>
                    <th class="text-center">Ações</th>

                </tr>
                </thead>
            </table>
            <!-- <div style="height:700px">
              <div id="gridbox" style="width:100%; height:100%; background-color:white;"></div>
            </div> -->
        </div>

        <div v-else-if="listagem == 'cadastro'">
            <TipoExecucoesCadastrar/>
        </div>

        <div v-else-if="listagem == 'editar'">
            <TipoExecucoesEditar :id='id'/>
        </div>
    </div>
</template>

<script>
    import Loading from '../login/Loading'
    import MenuInternoCadastros from '../menu-interno/MenuInternoCadastros.vue'
    import TipoExecucoesCadastrar from '../execucoes/TipoExecucoesCadastrar.vue'
    import TipoExecucoesEditar from '../execucoes/TipoExecucoesEditar.vue'

    var gridSituacoes;

    export default {
        name: 'TipoExecucoes',
        components: {
            MenuInternoCadastros,
            TipoExecucoesCadastrar,
            TipoExecucoesEditar,
            Loading
        },
        data() {
            return {
                listagem: 'listagem',
                paginaTop: '',
                id: ''
            }
        },
        methods: {
            viewAdicionar() {
                this.listagem = 'cadastro';
                this.paginaTop = 'ADICIONAR TIPO DE EXECUÇÕES',
                    $('#tabela').parents('div.dataTables_wrapper').first().hide();
            }
        },
        mounted: function () {

            let thiss = this;
            let swall = this.$swal;

            let tabela = $('#tabela').DataTable({
                "oLanguage": {
                    "sSearch": "Pesquisar:",
                    "sEmptyTable": "Nenhum dado para exibição",
                    "sZeroRecords": "Nenhum dado encontrado",
                    "oPaginate": {
                        "sNext": "Próximo",
                        "sPrevious": "Anterior",
                    },
                    "sLengthMenu": "Mostrar _MENU_ dados",
                    "sInfoFiltered": " - (filtrado de _MAX_ dados)",
                    "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ dados",
                },
                "ajax": {
                    "url": axios.defaults.baseURL + "/api/sist-obras/execucoes",
                    dataSrc: '',
                    headers: {
                        'Authorization': `Bearer ${Store.getters.pegaAccessToken}`
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        API.geraNovoTokenDatatable(jqXHR, tabela);
                    }
                },
                "columns": [
                    {"data": "c06_id", visible: false},
                    {"data": "c06_descr"},
                    {
                        targets: [2],
                        width: '10%',
                        orderable: false,
                        mData: data => criarBotoes(data.c06_id)
                    }
                ],
                'fnDrawCallback': function () {

                    $('.editar').on('click', function () {
                        var dados = $(this).data('id');
                        thiss.id = dados;
                        thiss.listagem = 'editar'
                        thiss.paginaTop = 'EDITAR'
                        $('#tabela').parents('div.dataTables_wrapper').first().hide();
                    })
                    $('.excluir').on('click', function () {
                        var dados = $(this).data('id');
                        thiss.id = dados;

                        swall({
                            title: "Atenção!",
                            text: "Deseja realmente excluir o Tipo de execução selecionado?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: 'Sim',
                            cancelButtonText: "Não!"
                        })
                            .then(
                                function () {
                                    API.enviarRequisicao('delete', '/api/sist-obras/execucoes/' + thiss.id)
                                        .then( resp => {
                                            swall('Atenção', 'O Tipo de Execução foi deletado com sucesso', 'success')
                                                .then(
                                                    function () {
                                                        history.go(0);
                                                    }
                                                )
                                        })
                                        .catch(error => {
                                            swall('Erro', 'O Tipo de Execução esta sendo usado em Obras', 'error')
                                        });
                                },
                                function () {
                                    return false;
                                });

                    })

                }
            });


            function criarBotoes(id, ctrl) {
                if (ctrl != null) {
                    return '<a href="#" class="btnEditar' + ctrl + ' btn btn_editar_rh btn-default btn-sm">' +
                        '<i class="fa fa-edit" data-toggle="tooltip" title="Editar"></i>' +
                        '</a>' +
                        '<a href="#" data-id="' + id + '" class="btn btn-sm btn-info' + ctrl + ' btn btn-default btn-sm">' +
                        '<i class="fa fa-trash" data-toggle="tooltip" title="Deletar"></i>' +
                        '</a>';
                } else {
                    return "<button class='btn btn-sm editar' data-id='" + id + "'><i class='fa fa-edit text-info' ></i></button>" +
                        "<button class='btn btn-sm excluir' data-id='" + id + "'><i class='fa fa-trash text-danger'></i></button>";
                }
            }

            // axios
            //   .get('http://192.168.1.17:8085/api/sist-obras/execucoes/dhtmlx')
            //   .then(response => {
            //     this.dados = response.data
            //     gridSituacoes.parse(this.dados, "json");

            //     let thiss = this;
            //     let swall = this.$swal;
            //     $('.hdrcell').css('text-align', 'center');
            //     $('.editar').on('click', function(){
            //       var dados = $(this).data('id');
            //       thiss.id = dados;
            //       thiss.listagem = 'editar';
            //       thiss.paginaTop = 'EDITAR';
            //     })

            //     $('.excluir').on('click', function(){
            //       var dados = $(this).data('id');
            //       thiss.id = dados;

            //       swall({
            //         title: "Atenção!",
            //         text: "Deseja realmente excluir a Situação/Status selecionada?",
            //         type: "warning",
            //         showCancelButton: true,
            //         confirmButtonText: 'Sim',
            //         cancelButtonText: "Não!"
            //       })
            //       .then(
            //           function () {
            //             axios
            //             .delete("http://192.168.1.17:8085/api/sist-obras/execucoes/"+thiss.id)
            //             .then(
            //                swall('Atenção', 'O Tipo de execução foi deletado com sucesso', 'success')
            //                .then(
            //                   function () {
            //                     history.go(0);
            //                   }
            //                 )
            //             )
            //             .catch(error => {
            //                 swall('Erro', 'O Tipo de Execução está sendo usado em Obras', 'error')
            //               });
            //           },
            //           function () {
            //             return false;
            //           });

            //     })
            //   })

            // gridSituacoes = new dhtmlXGridObject('gridbox');
            // gridSituacoes.setImagePath("libs/imgs/");
            // gridSituacoes.setHeader("Código, Descrição, Ações");
            // gridSituacoes.setInitWidths("70,850,105");
            // gridSituacoes.setColAlign("left,left,left");
            // gridSituacoes.setColTypes("ro,ro,ro");
            // gridSituacoes.setColSorting("int,str");
            // gridSituacoes.attachEvent("onRowCreated",function(id){
            //     this.cells(id,2).setValue("<button class='btn btn-sm editar' data-id='"+id+"'><i class='fa fa-edit text-info' ></i></button><button class='btn btn-sm excluir' data-id='"+id+"'><i class='fa fa-trash text-danger'></i></button>");
            //     return true;
            // });
            // gridSituacoes.init();
            // gridSituacoes.attachHeader("&nbsp;,#text_filter");
            // // gridSituacoes.enableSmartRendering(true, 50);
            // gridSituacoes.setColumnHidden(0,true);

        }
    }
</script>

<style scoped>

    h2 {
        color: #5377C1;
    }

    a {
        background-color: #18A689;
        color: #fff;
        font-size: 12px;
        text-decoration: none;
    }

</style>
